import { STORE_NAME } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { UserInfo } from '@intigral/domain';
import { IProfileService } from '@intigral/domain/lib/application/services/ProfileService';
import { get, set } from '@intigral/utils/lib/browser-storage/localStorage';
import { getGlobalQueryClient } from '../hooks/useConfiguration';
import { getSelectedProfileKidsMode, getUserInfo } from './user';

export const getProfileListQueryKey = (kidsMode: boolean) => ['profiles', 'user-profile-list', kidsMode] as const;

const transformProfilesResponse = (profilesList: any, requestKidsMode: boolean) => {
    const { profiles, profilesRev, profilesLimit, parentalLockOn } = profilesList;
    let regProfileIndex = 0;

    return {
        parentalLockOn: parentalLockOn ?? 0,
        profiles: profiles?.map((el) => {
            if (!el.kidsMode) {
                el.avatarIndex = regProfileIndex;
                regProfileIndex++;
            }

            return el;
        }),
        profilesLimit: profilesLimit,
        profileRev: profilesRev,
        kidsMode: requestKidsMode,
        date: new Date().getTime(),
    };
};

export const fetchProfileList = async (user: UserInfo) => {
    const profileService = container.resolve<IProfileService>(DI.SERVICES.IProfileService);
    const requestKidsMode = getSelectedProfileKidsMode();
    const profilesList = await profileService.getProfiles(
        user.apiKey,
        user.authToken,
        user?.identityToken,
        requestKidsMode
    );
    const result = transformProfilesResponse(profilesList, requestKidsMode);
    set(STORE_NAME.USER_PROFILE_LIST, result);
    return result;
};

export const refreshProfileListQuery = async () => {
    const userInfo = getUserInfo();
    if (!userInfo?.apiKey) {
        return null;
    }

    const kidsMode = getSelectedProfileKidsMode();
    const queryKey = getProfileListQueryKey(kidsMode);
    const queryClient = getGlobalQueryClient();

    if (queryClient) {
        return queryClient.fetchQuery({
            queryKey,
            queryFn: () => fetchProfileList(userInfo),
            staleTime: Infinity,
        });
    }

    return fetchProfileList(userInfo);
};

export const getProfileListFromCache = () => get(STORE_NAME.USER_PROFILE_LIST);
